import React, { Component } from "react";
import UserLinks from "../UserLinks/UserLinks";
import MainLinks from "../MainLinks";
import "./ToolbarActions.scss";
import logo from './img/logo.png';

class Toolbar extends Component {
  render() {
    const { config } = this.props;
    return (
      <div className="toolbar-actions">
        <div className="logo-wrapper"><a href="/"><img src={logo} className="logo" alt="محمد عزازي"/></a></div>
        <div className="userlinks-container">
          <MainLinks config={config} labeled />
        </div>
      </div>
    );
  }
}

export default Toolbar;



// WEBPACK FOOTER //
// ./src/components/ToolbarActions/ToolbarActions.jsx